import { SHOP_API_URLS } from "@/config/apiConfig";
import { ShopResponse } from "@/types/shop";

const getAuthToken = (): string => {
  if (typeof window === "undefined") return "";
  return localStorage.getItem("token") || "";
};

export const getAllShops = async (): Promise<ShopResponse[]> => {
  const token = getAuthToken();
  const response = await fetch(`${SHOP_API_URLS.GET_ALL_SHOPS}?limit=500`, {
    method: "GET",
    headers: { "Content-Type": "application/json", Authorization: token },
  });
  if (!response.ok) throw new Error("Failed to get all shops");
  const result = await response.json();
  const items = result?.data?.items;
  return Array.isArray(items) ? items : [];
};

export const getShopById = async (name: string): Promise<ShopResponse> => {
  const token = getAuthToken();
  const response = await fetch(
    `${SHOP_API_URLS.GET_SHOP_BY_ID}?name=${encodeURIComponent(name)}`,
    {
      method: "GET",
      headers: { "Content-Type": "application/json", Authorization: token },
    }
  );
  if (!response.ok) throw new Error("Failed to get shop by id");
  const result = await response.json();
  return result?.data?.item ?? result?.data ?? result;
};

export const createShop = async (shop: Partial<ShopResponse>): Promise<any> => {
  const token = getAuthToken();
  const response = await fetch(SHOP_API_URLS.CREATE_SHOP, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: token },
    body: JSON.stringify(shop),
  });
  if (!response.ok) throw new Error("Failed to create shop");
  const result = await response.json();
  return result?.data?.item ?? result?.data ?? result;
};

export const updateShop = async (name: string, shop: Partial<ShopResponse>): Promise<any> => {
  const token = getAuthToken();
  const response = await fetch(SHOP_API_URLS.UPDATE_SHOP, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: token },
    body: JSON.stringify({ name, ...shop }),
  });
  if (!response.ok) throw new Error("Failed to update shop");
  const result = await response.json();
  return result?.data?.item ?? result?.data ?? result;
};

export const deleteShop = async (name: string): Promise<any> => {
  const token = getAuthToken();
  const response = await fetch(SHOP_API_URLS.DELETE_SHOP, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: token },
    body: JSON.stringify({ name }),
  });
  if (!response.ok) throw new Error("Failed to delete shop");
  const result = await response.json();
  return result?.data ?? result;
};
